import { render, staticRenderFns } from "./RelativeSimple.vue?vue&type=template&id=9bd71770&"
import script from "./RelativeSimple.vue?vue&type=script&lang=js&"
export * from "./RelativeSimple.vue?vue&type=script&lang=js&"
import style0 from "./RelativeSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bd71770')) {
      api.createRecord('9bd71770', component.options)
    } else {
      api.reload('9bd71770', component.options)
    }
    module.hot.accept("./RelativeSimple.vue?vue&type=template&id=9bd71770&", function () {
      api.rerender('9bd71770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/RelativeSimple.vue"
export default component.exports